import { render, staticRenderFns } from "./ButtonCardActions.vue?vue&type=template&id=cbc4752c"
import script from "./ButtonCardActions.vue?vue&type=script&lang=js"
export * from "./ButtonCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports